module.exports = __webpack_public_path__ + "static/media/down-chevron-grey.e209adff.svg";